export default "__VITE_ASSET__lt5kUTCI__"